<template>
  <div class="width98 margin-auto" style="background: #f6f7fb">
    <div class="width100" style="height: 1px"></div>
    <div class="headbox width100 backwhite flex-betweenNowrapAlign f12">
      <div class="flex width50 margin-top10">
        <img class="headimg" :src="dcadminavatar" alt="" />
        <div class="lineheight30 pad-left20">
          <p class="headtitle">
            {{ dccompany }}
            <span v-if="dctypes == 1">
              <span
                class="dctype"
                v-for="(item, index) in dcflags"
                :key="index"
              >
                <el-tooltip
                  class="item cursorpointer"
                  effect="light"
                  :content="item.flag + ' ' + item.year"
                  placement="top"
                >
                  <span>{{ item.flag }}</span>
                </el-tooltip>
              </span>
            </span>
          </p>
          <p class="welcontit">
            <img
              class="homestanding"
              src="@/assets/barsvg/standing.svg"
              alt=""
            />
            <span style="color: #353a44" class="margin-right10 f12">{{
              dcadminNickname
            }}</span>
            <span class="f12"> 联系电话：{{ dcadminMobile }}</span>
          </p>
        </div>
      </div>
      <div class="flex-aroundnowrap width46 pad-right10">
        <div class="titlerightitem titlerightitem1">
          <img class="itemimg" src="@/assets/barsvg/1@3x.png" alt="" />
          <div class="itemcont">
            <p>高新技术</p>
            <p>企业测评</p>
          </div>
        </div>
        <div class="titlerightitem titlerightitem2">
          <img class="itemimg" src="@/assets/barsvg/2@3x.png" alt="" />
          <div class="itemcont">
            <p>专精特新</p>
            <p>企业测评</p>
          </div>
        </div>
        <div class="titlerightitem titlerightitem3">
          <img class="itemimg" src="@/assets/barsvg/3@3x.png" alt="" />
          <div class="itemcont">
            <p>数字化车间</p>
            <p>测评</p>
          </div>
        </div>
      </div>
    </div>
    <div class="width100 margin-top10 flex-betweenNowrapAligns f14">
      <div class="width33 border-rd3 backwihte">
        <div class="pad-top20 pad-left20 pad-bot5 flex-betweenwrap">
          <div class="flex">
            <span class="dimensional">六维创新指数</span>
            <div class="sss">{{ value4 }}</div>
          </div>
          <p class="pad-right20">
            超过了 <span style="color: #4bd6cd">{{ value3 }}%</span> 的企业
          </p>
        </div>

        <!-- 指标 -->
        <div class="indicatrix">
          <div class="echarts-box" id="main"></div>
        </div>
      </div>
      <div class="width33 border-rd3 backwihte">
        <div class="pad-top20 pad-left20 pad-bot5">
          <span class="dimensional">实时通报</span>
        </div>
        <div class="indicatrix">
          <div class="echarts-box flex-betweennocenter">
            <div class="notification margin-top10">
              <div class="flex-betweenwrap indicatrixitem">
                <p><span>知识产权</span> <span class="mesgenum">99</span></p>
                <img src="@/assets/barsvg/sy-tz.svg" alt="" />
              </div>
              <div class="indicatrixitem1">
                <span><span class="wordcorlor">2</span> 件专利即将到期</span>
              </div>
              <div class="indicatrixitems"><span> 3件专利申请中</span></div>
              <div class="indicatrixitems"><span> 5件商标注册申请中</span></div>
              <div class="indicatrixitems"><span> 5件商标注册申请中</span></div>
              <div class="indicatrixitems"><span> 2件专利即将到期</span></div>
              <div class="indicatrixitems"><span> 2件专利即将到期</span></div>
            </div>
            <div class="notification margin-top10">
              <div class="flex-betweenwrap indicatrixitem">
                <p>
                  <span>热点政策</span>
                  <span class="mesgenum">{{ page2total }}</span>
                </p>
                <img
                  @click="toScience"
                  src="@/assets/barsvg/sy-tz.svg"
                  alt=""
                />
              </div>
              <div class="indicatrixitem1">
                <span
                  >最近更新了<span class="wordcorlor">{{ page2total }}</span>
                  条政策</span
                >
              </div>
              <div
                class="indicatrixitems text-ellipsis cursorpointer"
                v-for="(item, index) in page2"
                :key="index"
              >
                <span @click="toPolicydetail(index)">
                  [{{ item.level }}] {{ item.title }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="width33 border-rd3 backwihte">
        <rdeacharts></rdeacharts>
      </div>
    </div>
    <div class="width100 margin-top10 flex-betweenNowrapAlign f14 pad-bot20">
      <div class="width33 border-rd3" style="height: 360px">
        <div
          class="flex-betweennowrap backwihte border-rd3"
          style="padding: 20px 20px 20px 20px"
        >
          <div class="flex-betweencen">
            <img class="itemimg" src="@/assets/barsvg/xmgl@3x.png" alt="" />
            <span class="dimensional margin-left20">项目管理</span>
          </div>
          <div
            class="f12 cursorpointer"
            style="color: #969eac"
            @click="totechnologyinformation"
          >
            立即进入
            <i slot="prefix" class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div
          class="backwihte margin-top10"
          style="padding: 20px 20px 30px 20px"
        >
          <p class="dimensional">项目进行</p>
          <div class="pad-top20" v-for="(item, index) in page1" :key="index">
            <p class="pad-bot10 text-ellipsis">
              {{ item.project.title }} ( {{ item.title }} )
            </p>
            <el-progress
              :percentage="item.progress * 100"
              :color="customColorMethod"
            ></el-progress>
          </div>
        </div>
      </div>
      <div class="width33 border-rd3 backwihte" style="height: 360px">
        <div class="flex-betweennowrap" style="padding: 20px 20px 10px 20px">
          <span class="dimensional">政策匹配</span>
          <span class="signmuch cursorpointer" @click="tomyScience"
            >查看更多</span
          >
        </div>
        <div class="indicatrix">
          <div class="flex-betweennowrap">
            <div class="width100">
              <div class="indicatrixitem2">您有新的政策匹配结果</div>
              <div
                class="indicatrixitems flex-betweennowrap text-ellipsis"
                v-for="(item, index) in pagemat"
                :key="index"
              >
                <p class="width80 text-ellipsis">
                  [{{ item.chance.level }}] {{ item.chance.title }}
                </p>
                <span>{{ item.score }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="width33 border-rd3 backwihte" style="height: 360px">
        <div class="flex-betweennowrap" style="padding: 20px 20px 10px 20px">
          <span class="dimensional">行业瞭望</span>
          <span class="signmuch cursorpointer" @click="toIndustry"
            >查看更多</span
          >
        </div>
        <div class="indicatrix">
          <div class="flex-betweennowrap">
            <div class="width100">
              <div class="indicatrixitem2">
                <span>
                  最近更新了
                  <span class="wordcorlor">4</span> 个行业发展报
                </span>
              </div>
              <div
                class="indicatrixitems text-ellipsis"
                v-for="(item, index) in pagetry"
                :key="index"
              >
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  policyList,
  entgrade,
  researchprojects,
  policymatchresult,
  projecttaskindex,
} from "@/api/Center/Center.api";
import {
  industryreportindex,
  entrdfeeindex,
  indexrdstat,
} from "@/api/newhead/newhead.api";
import * as echarts from "echarts";
import BUS from "@/BUS/BUS";
import rdeacharts from "./rdeacharts.vue";
import { personalInformation } from "@/api/personal/personal.api";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      avatar: "",
      last_ip: "",
      realname: "",
      phonnumber: "",
      personcreate_time: "",
      page1: [],
      page2: [],
      page2total: "",
      pagetry: [],
      pagetrytotal: "",
      pagemat: [],
      pagemattotal: "",
      pagerd: [],
      pagerdtotal: "",
      thisNum: 1,
      thisNums: 1,
      page: [],
      pages: [],
      date: "",
      value4: "",
      dccompany: "",
      dcflags: [],
      value3: "",
      dcadminNickname: "",
      dcadminMobile: "",
      dcadminavatar: "",
      screenWidth: null,
      dctypes: 1,
    };
  },

  components: { rdeacharts },

  methods: {
    customColorMethod(percentage) {
      if (percentage < 30) {
        return "#F96D68";
      } else if (percentage < 70) {
        return "#7B83EA";
      } else {
        return "#4BD6CD";
      }
    },
    //研发中的项目
    totechnologyinformation() {
      this.$router.push({
        path: "/development-Administration/Science-projects",
      });
    },
    // 知识产权
    tointellectual() {
      this.$router.push({
        path: "/intellectual-property/Management-patents",
      });
    },
    // 政策列表
    toScience() {
      this.$router.push({
        path: "/Science-technology/Policy-items",
      });
    },
    // 研发投入
    toexpenses() {
      this.$router.push({
        path: "/expenses-money/Cost-collection",
      });
    },
    // 政策列表
    tomyScience() {
      this.$router.push({
        path: "/Science-technology/Policy-items",
      });
    },
    // 行业瞭望
    toIndustry() {
      this.$router.push({
        path: "/Industry-Outlook/Industry-report",
      });
    },
    // 创新政策详情
    toPolicydetail(index) {
      window.sessionStorage.setItem("policydetailid", this.page2[index].id);
      this.$router.push({
        path: "/Science-technology/Policyitems-details",
      });
    },
  },
  created() {
    //项目
    projecttaskindex({
      page: this.thisNum,
      limit: 3,
    }).then((res) => {
      if (res.data.code == 200) {
        this.page1 = res.data.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 政策
    policyList({
      page: this.thisNum,
      limit: 5,
    }).then((res) => {
      if (res.data.code == 200) {
        this.page2 = res.data.data.data;
        this.page2total = res.data.data.total;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 费用-研发投入
    entrdfeeindex({
      page: this.thisNum,
      limit: 4,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagerd = res.data.data.data;
        this.pagerdtotal = res.data.data.total;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });

    // 获取企业政策匹配结果
    policymatchresult({
      limit: 5,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagemat = res.data.data.data;
        this.pagemattotal = res.data.data.total;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 行业瞭望-产业报告
    industryreportindex({
      page: this.thisNum,
      limit: 5,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagetry = res.data.data.data;
        this.pagetrytotal = res.data.data.total;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });

    // 获取个人信息
    const id = window.sessionStorage.getItem("id");
    personalInformation({ id: id }).then((res) => {
      if (res.data.code == 200) {
        if (
          res.data.data.company.company == undefined ||
          res.data.data.company.company == null ||
          res.data.data.company.company == ""
        ) {
          this.dccompany == "个人版";
        } else {
          this.dccompany = res.data.data.company.company;

          if (
            res.data.data.company.flags != undefined ||
            res.data.data.company.flags != null ||
            res.data.data.company.flags != ""
          ) {
            this.dcflags = res.data.data.company.flags;
          }
        }
        window.sessionStorage.setItem(
          "default",
          res.data.data.user.default_cid
        );
        window.sessionStorage.setItem(
          "authority",
          res.data.data.bind.authority
        );
        this.phonnumber = res.data.data.user.mobile;
        this.nickname = res.data.data.user.nickname;
        this.mobile = res.data.data.user.mobile;
        this.realname = res.data.data.user.realname;
        this.address = res.data.data.user.address;
        this.last_ip = res.data.data.user.last_ip;
        this.personcreate_time = res.data.data.user.create_time;

        this.dcadminNickname = res.data.data.company.admin.nickname;
        this.dcadminMobile = res.data.data.company.admin.mobile;

        if (res.data.data.company.admin.avatar.indexOf("http") == -1) {
          this.dcadminavatar =
            window.g.Apisrc + res.data.data.company.admin.avatar;
        } else {
          this.dcadminavatar = res.data.data.company.admin.avatar;
        }
        if (res.data.data.user.avatar.indexOf("http") == -1) {
          this.avatar = window.g.Apisrc + res.data.data.user.avatar;
        } else {
          this.avatar = res.data.data.user.avatar;
        }
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("avatar", (data) => {
      this.avatar = data;
    });
    BUS.$on("scrollwidth", (n) => {
      if (n <= 1330 && this.dcflags.length == 1) {
        this.dctypes = 0;
      } else if (n <= 1430 && this.dcflags.length == 2) {
        this.dctypes = 0;
      } else if (n <= 1530 && this.dcflags.length == 3) {
        this.dctypes = 0;
      } else if (n <= 1630 && this.dcflags.length == 4) {
        this.dctypes = 0;
      } else {
        this.dctypes = 1;
      }
    });
    // 获取图表数据
    entgrade().then((res) => {
      const value1 = [
        res.data.data.grade.rd_direction,
        res.data.data.grade.rd_investment,
        res.data.data.grade.ip,
        res.data.data.grade.transformation,
        res.data.data.grade.rd_team,
        res.data.data.grade.benefits,
      ];
      const value2 = [
        parseInt(res.data.data.grade_avg[0].rd_direction),
        parseInt(res.data.data.grade_avg[0].rd_investment),
        parseInt(res.data.data.grade_avg[0].ip),
        parseInt(res.data.data.grade_avg[0].transformation),
        parseInt(res.data.data.grade_avg[0].rd_team),
        parseInt(res.data.data.grade_avg[0].benefits),
      ];
      this.value3 = res.data.data.grade.top;
      this.value4 = res.data.data.grade.grade;
      var chartDom = document.getElementById("main");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        color: ["#52C6CC", "#6A73E6"],

        legend: {
          data: ["企业值", "平均值"],
          bottom: "-1%",
        },

        radar: {
          indicator: [
            { name: "研发方向", max: 20, color: "#333" },
            { name: "研发投入", max: 20, color: "#333" },
            { name: "知识产权", max: 20, color: "#333" },
            { name: "研发成果转化", max: 20, color: "#333" },
            { name: "研发团队", max: 20, color: "#333" },
            { name: "市场效益", max: 20, color: "#333" },
          ],
          radius: "70%",
          //雷达图背景的颜色，在这儿随便设置了一个颜色，完全不透明度为0，就实现了透明背景
          // splitArea: {
          //   show: false,
          //   areaStyle: {
          //     color: "rgba(121,237,252,.3)", // 图表背景的颜色
          //   },
          // },
          // splitLine: {
          //   show: true,
          //   lineStyle: {
          //     width: 1,
          //     color: "#409eff", // 设置网格的颜色
          //   },
          // },
        },

        series: [
          {
            name: "name",
            type: "radar",
            data: [
              {
                value: value1,
                name: "企业值",
                areaStyle: { color: "rgba(71,237,252,.3)" }, //雷达覆盖区域背景颜色
              },
              {
                value: value2,
                name: "平均值",
                areaStyle: { color: "rgba(71,23,22,.3)" }, //雷达覆盖区域背景颜色
              },
            ],
          },
        ],
      };
      option && myChart.setOption(option);

      window.addEventListener("resize", function () {
        myChart.resize();
      });
      // window.onresize = myChart.resize;
    });
  },
};
</script>
<style scoped>
.headimg {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-left: 20px;
  margin-bottom: 20px;
}
.headbox {
  border-radius: 3px;
  margin: 10px auto 0;
  padding: 20px 0;
}
.homestanding {
  position: relative;
  top: 4px;
  margin-right: 10px;
}
.headtitle {
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #353a44;
  font-weight: 600;
}
.dctype {
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #4486ff;
  font-weight: 600;
  background-color: #e4fcfd;
  padding: 2px 8px;
  margin-left: 5px;
  border-radius: 10px;
  border: 1px solid #cae4e6;
}
.welcontit {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #969eac;
  font-weight: 400;
}
.titlerightitem {
  min-width: 200px;
  width: 28%;
  height: 90px;
  border-radius: 8px;
  padding: 0 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.titlerightitem1 {
  margin-right: 30px;
  background-image: linear-gradient(135deg, #ffdb58 0%, #ff793e 100%);
  box-shadow: 0px 10px 15px -10px rgba(255, 64, 6, 0.959);
}
.titlerightitem2 {
  margin-right: 30px;
  background-image: linear-gradient(135deg, #2ce9e2 0%, #2fabea 100%);
  box-shadow: 0px 10px 15px -10px rgba(6, 155, 255, 0.959);
}
.titlerightitem3 {
  background-image: linear-gradient(135deg, #81a7f8 0%, #4465ff 100%);
  box-shadow: 0px 10px 15px -10px rgba(6, 23, 255, 0.959);
}
.itemimg {
  width: 52px;
  height: 52px;
}
.itemcont {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #ffffff;
  line-height: 22px;
  font-weight: 500;
  text-align: left;
}
.dimensional {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #353a44;
  line-height: 16px;
  font-weight: 600;
}
.sss {
  width: 30px;
  height: 16px;
  text-align: center;
  line-height: 16px;
  margin-left: 10px;
  color: #f96d68;
  background: #fceceb;
  border: 1px solid #f96d68;
  font-size: 12px;
  border-radius: 15px;
}
.mesgenum {
  background: #f96d68;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  padding: 0 5px 0 5px;
  color: #fff;
  margin-left: 5px;
}

.notification {
  width: 48.5%;
  /* height: 320px; */
  position: relative;
  top: 10px;
  background: #ffffff;
  border: 1px dashed rgba(240, 240, 240, 1);
  border-radius: 3px;
}
.wordcorlor {
  color: #f96d68;
}
.signmuch {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #4bd6cd;
  line-height: 12px;
  font-weight: 400;
}
.indicatrixitem {
  height: 55px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #353a44;
  line-height: 55px;
  font-weight: 600;
  padding: 0 15px 0 15px;
}
.indicatrixitem1 {
  height: 36px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #6a7589;
  line-height: 36px;
  font-weight: 400;
  background: #f6f7fb;
  border-radius: 3px;
  padding: 0 15px 0 15px;
}
.indicatrixitem2 {
  height: 45px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #6a7589;
  line-height: 45px;
  font-weight: 400;
  border-radius: 3px;
  padding: 0 15px 0 10px;
}
.indicatrixitems {
  font-family: PingFangSC-Regular;
  height: 50px;
  font-size: 14px;
  color: #353a44;
  line-height: 50px;
  font-weight: 500;
  padding: 0 15px 4px 10px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
.Retrieveform {
  background: #fff;
}
.pagination {
  border-bottom: 1px solid #cacaca;
}
.Tablename {
  background: #dfdfdf;
  color: #b1b1b1;
}
.Tablecont {
  border-bottom: 1px solid #efefef;
}
.dark-theme {
  width: 100%;
  margin: auto;
  border-bottom: 1px solid #f1f1f1;
  color: #525252;
}
.light-theme {
  width: 100%;
  margin: auto;
  border-bottom: 1px solid #f1f1f1;
  color: #b1b1b1;
}
/* 指标 */
.indicatrix {
  width: 96%;
  margin: auto;
}
.echarts-box {
  width: 100%;
  height: 365px;
  /* background: #f2f2f2; */
  position: relative;
  top: -10px;
}
.label-box {
  width: 100%;
  position: relative;
}
</style>